































































































































































































































import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { LocaleMessage } from 'vue-i18n'
import { mapGetters } from 'vuex'

import CommonModal from '@/components/common/CommonModal.vue'
import CommonButton from '@/components/common/CommonButton.vue'

type PostType = 0 | 1 | 2

export interface Subscription {
  id: number
  label: string
}

export interface PostFile {
  id: number
  file: File | string
  type?: number | string
  mime?: string | null
}

export interface Post {
  id: number
  type: PostType
  text: string
  subscriptions: Subscription[]
  attachments: PostFile[]
  comments: boolean
  promotional_page_id?: number
}

@Component({
  components: { CommonButton, CommonModal },
  computed: {
    ...mapGetters('builder', {  promotionalPage: 'getPromotionalPage',appType: 'getAppType' })
  }
})

export default class BuilderCreatePostModal extends Vue {

  promotionalPage!: any
  appType!: string
  appendPromotionalPage = false

  @Ref() fileRef!: HTMLInputElement

  @Prop({ default: false, type: Boolean }) create!: boolean

  @Prop({ required: true, type: Object }) readonly value!: Post

  @Prop({ required: true, type: Array })
  readonly subscriptions!: Subscription[]

  get acceptFiles(): string {
    return this.value.type === 1 ? 'image/*' : 'video/*'
  }

  get subscriptionsMap(): Record<number, boolean> {
    return this.value.subscriptions.reduce((agg, cur) => ({ ...agg, [cur.id]: true }), {})
  }

  get isSubmitButtonDisabled(): boolean {
    switch (this.value.type) {
      case 0:
        return !this.value.text
      default:
        return !this.value.attachments.length || this.value.attachments.some((f) => !f.file)
    }
  }
  get activeTypeAttachments(): PostFile[] {
    
    return this.value.attachments.map(item => {
      if('mime' in item && typeof item.mime === 'string') {
        item.type = item.mime?.split('/')[0] === 'video' ? 2 : 1
      }
      return item
    }).filter(item => item.type === this.value.type)
  }
  get activeTitle(): string | LocaleMessage {
    switch (this.value.type) {
      case 0:
        return this.$t('text')
      case 1:
        return this.$t('photo')
      case 2:
        return this.$t('video')
      default:
        return ''
    }
  }

  get fileUrls(): string[] {
     return this.value.attachments
      .filter((item) => item.type == this.value.type)
      .map(item => item.file instanceof File ? URL.createObjectURL(item.file) : item.file)
  }
  addPromotionalPage(): void {
    if(this.appendPromotionalPage) {
      this.value.promotional_page_id = this.promotionalPage?.id
    } else {
      delete this.value.promotional_page_id
    }
    
  }
  onTextChange(text: string): void {
    this.$emit('change', { key: 'text', value: text })
  }

  onCommentsClick(): void {
    this.$emit('change', { key: 'comments', value: !this.value.comments })
  }

  onFileRemove(fileId: number): void {
    if (this.value.type === 1 || this.value.type === 2) {
      this.$emit('change', {
        key: 'attachments',
        value: this.value.attachments.filter(({ id }) => id !== fileId),
      })
    }
  }

  onFileChange(files: File[]): void {
    const filesToAdd = [...files].map((file, i) => ({
      id: -Number(Date.now().toString()) - i,
      file,
      type: this.value.type
    }))

    switch (this.value.type) {
      case 1:
      case 2:
        this.$emit('change', {
          key: 'attachments',
          value: [...this.value.attachments, ...filesToAdd],
        })
        break
      default:
    }
  }

  onTypeChange(type: 0 | 1 | 2): void {
    this.$emit('change', {
      key: 'type',
      value: type,
    })
  }

  onSubscriptionChange(val: Subscription): void {
    this.$emit('change', {
      key: 'subscriptions',
      value: this.subscriptionsMap[val.id]
        ? this.value.subscriptions.filter((s) => s.id !== val.id)
        : [...this.value.subscriptions, val],
    })
  }

  created(): void {
    this.value.type = 1
    if('promotional_page_id' in this.value && typeof this.value['promotional_page_id'] === 'number') {
      this.appendPromotionalPage = true
    }
  }
}
